export function toggleItem() {
	document.querySelectorAll('.toggle.hide').forEach((item) => {
		const button = item.querySelector('.toggle__button')
		if (button) {
			button.addEventListener('click', () => {
				item.classList.toggle('hide')
			})
		}
	})
}
